const version = 'api/v1';
const base = 'https://iszg9dimg9.execute-api.ap-south-1.amazonaws.com';
// const base = 'http://localhost:8080';
export const environment = {
  production: false,
  BaseUrl: base,
  version: version,
  consoleFlag: true,

  login_service: `login-service/${version}`,
  user_service: `user-service/${version}`,
  platform_service: `platform-service/${version}`,
  core_service: `core-service/${version}`,
  common_service: `common-service/${version}`,
  subscription_service: `subscription-service/${version}`,

  captcha_siteKey: '6LcaXqwrAAAAAGbgMZdU6iI_SAs5AP40YEkxfrIW',
  captcha_secretKey: '6LcaXqwrAAAAAIqsVdlPmOmzlzyoUkT7tfYkyLFS',
  razorpayKey: 'rzp_test_cQ3yKzH9AqJdfZ',
  firebaseConfig: {
    apiKey: 'AIzaSyB5uD_3VgTFF4jegMhhUbIoimV15exEdZQ',
    authDomain: 'icxbee-sit.firebaseapp.com',
    projectId: 'icxbee-sit',
    storageBucket: 'icxbee-sit.firebasestorage.app',
    messagingSenderId: '918590975682',
    appId: '1:918590975682:web:9fadd394f7c6c349e8155b',
    measurementId: 'G-S2MC8SQECD',
  },
  auth: {
    sessionTimeout: 14 * 24 * 60 * 60 * 1000, // 14 days in milliseconds
    refreshThreshold: 5 * 60 * 1000, // Refresh token 5 minutes before expiry
    maxRetries: 3,
    persistenceType: 'local', // 'local', 'session', 'none'
  },
};
